import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useRouteMatch } from 'react-router';
import { useActionDispatcher } from '../../hooks';
import VideoMenuForm from './VideoMenuForm';
import {
  getVideoMenuRequest,
  resetCurrentVideoMenu,
  saveVideoMenuRequest,
} from '../../store/modules/video-menus/actions';
import { selectVideoMenu } from '../../store/modules/video-menus/selectors';
import TabRedirect from '../../components/tab-redirect/TabRedirect';

const VideoMenuEdit = () => {
  const dispatch = useDispatch();

  const videoMenu = useSelector(selectVideoMenu);

  const match = useRouteMatch<{
    id: string;
  }>()!;

  const videoMenuId = videoMenu.data?.id;
  useEffect(() => {
    const matchId = parseInt(match.params.id, 10);
    if (!videoMenuId || matchId !== videoMenuId) {
      dispatch(getVideoMenuRequest(matchId));
    }
  }, [dispatch, match.params.id, videoMenuId]);

  useEffect(() => () => {
    dispatch(resetCurrentVideoMenu());
  }, [dispatch]);

  const saveVideoMenu = useActionDispatcher(saveVideoMenuRequest);

  return (
    <>
      <TabRedirect />
      <VideoMenuForm
        record={videoMenu}
        onSubmit={saveVideoMenu}
      />
    </>
  );
};

export default VideoMenuEdit;
